import React from 'react';
import { CustomNodeProps } from './types.ts';


const CustomNode: React.FC<CustomNodeProps> = ({
                                                 x = 0,
                                                 y = 0,
                                                 width = 10,
                                                 height = 10,
                                                 color = '',
                                               }) => {
  const safeX = isNaN(x) ? 0 : x;
  const safeY = isNaN(y) ? 0 : y;
  const safeWidth = isNaN(width) ? 10 : width;
  const safeHeight = isNaN(height) ? 10 : height;

  return (
    <g>
      <rect
        x={safeX}
        y={safeY}
        width={safeWidth}
        height={safeHeight}
        fill={color}
        stroke={color}
      />
    </g>
  );
};

export default CustomNode;
